import React from "react"

import MarkdownHelper from '../../utils/MarkdownHelper'
import ReactMarkdown from "react-markdown"

const Table = ({ table }) => {
    
    const tableCol = [];
    
     tableCol[0] = Object.keys(table)
        .filter(el=>el.includes('table_s1')).sort().map(el=>table[el]);
     tableCol[1] = Object.keys(table)
        .filter(el=>el.includes('table_s2')).sort().map(el=>table[el]);
     tableCol[2] = Object.keys(table)
        .filter(el=>el.includes('table_s3')).sort().map(el=>table[el]);
     tableCol[3] = Object.keys(table)
        .filter(el=>el.includes('table_s4')).sort().map(el=>table[el]);
     
     
     
    const tableImagesHelper = [];
    
    let tableImages = [];
    
    tableImagesHelper[0] = '';
    tableImagesHelper[1] = table['table_s2-kreditkarten-image-url-s2'] ? table['table_s2-kreditkarten-image-url-s2'] : '';
    tableImagesHelper[2] = table['table_s3-kreditkarten-image-url-s3'] ? table['table_s3-kreditkarten-image-url-s3'] : '';
    tableImagesHelper[3] = table['table_s4-kreditkarten-image-url-s4'] ? table['table_s4-kreditkarten-image-url-s4'] : '';
    
    if (tableImagesHelper[0] +
        tableImagesHelper[1] +
        tableImagesHelper[2] +
        tableImagesHelper[3] !== ''){
        tableImages = tableImagesHelper
    };
    
    
    
    const tableTitlesHelper = [];
    
    let tableTitles = [];
    
    tableTitlesHelper[0] = '';
    tableTitlesHelper[1] = table['table_s2-headline-spalte-02'] ? table['table_s2-headline-spalte-02'] : '';
    tableTitlesHelper[2] = table['table_s3-headline-spalte-03'] ? table['table_s3-headline-spalte-03'] : '';
    tableTitlesHelper[3] = table['table_s4-headline-spalte-04'] ? table['table_s4-headline-spalte-04'] : '';
    
    if (tableTitlesHelper[0] +
        tableTitlesHelper[1] +
        tableTitlesHelper[2] +
        tableTitlesHelper[3] !== ''){
        tableTitles = tableTitlesHelper
    };
   
    
    
    const tableRows = [];
  
    const tableRow1 = [];
    
    tableRow1[0] = table['table_s1-zeile-01'] ? table['table_s1-zeile-01'] : '';
    tableRow1[1] = table['table_s2-zeile-01'] ? table['table_s2-zeile-01'] : '';
    tableRow1[2] = table['table_s3-zeile-01'] ? table['table_s3-zeile-01'] : '';
    tableRow1[3] = table['table_s4-zeile-01'] ? table['table_s4-zeile-01'] : '';
    
    if (tableRow1[0] +
        tableRow1[1] +
        tableRow1[2] +
        tableRow1[3] !== ''){
        tableRows[0] = tableRow1
    };
    
    
    
    const tableRow2 = [];
    tableRow2[0] = table['table_s1-zeile-02'] ? table['table_s1-zeile-02'] : '';
    tableRow2[1] = table['table_s2-zeile-02'] ? table['table_s2-zeile-02'] : '';
    tableRow2[2] = table['table_s3-zeile-02'] ? table['table_s3-zeile-02'] : '';
    tableRow2[3] = table['table_s4-zeile-02'] ? table['table_s4-zeile-02'] : '';
    
    if (tableRow2[0] +
        tableRow2[1] +
        tableRow2[2] +
        tableRow2[3] !== ''){
        tableRows[1] = tableRow2
    };
    
    
    
    const tableRow3 = [];
    tableRow3[0] = table['table_s1-zeile-03'] ? table['table_s1-zeile-03'] : '';
    tableRow3[1] = table['table_s2-zeile-03'] ? table['table_s2-zeile-03'] : '';
    tableRow3[2] = table['table_s3-zeile-03'] ? table['table_s3-zeile-03'] : '';
    tableRow3[3] = table['table_s4-zeile-03'] ? table['table_s4-zeile-03'] : '';
    
    if (tableRow3[0] +
        tableRow3[1] +
        tableRow3[2] +
        tableRow3[3] !== ''){
        tableRows[2] = tableRow3
    };
        
    const tableRow4 = [];
    tableRow4[0] = table['table_s1-zeile-04'] ? table['table_s1-zeile-04'] : '';
    tableRow4[1] = table['table_s2-zeile-04'] ? table['table_s2-zeile-04'] : '';
    tableRow4[2] = table['table_s3-zeile-04'] ? table['table_s3-zeile-04'] : '';
    tableRow4[3] = table['table_s4-zeile-04'] ? table['table_s4-zeile-04'] : '';
    
    if (tableRow4[0] +
        tableRow4[1] +
        tableRow4[2] +
        tableRow4[3] !== ''){
        tableRows[3] = tableRow4
    };
    
    
    
    const tableRow5 = [];
    tableRow5[0] = table['table_s1-zeile-05'] ? table['table_s1-zeile-05'] : '';
    tableRow5[1] = table['table_s2-zeile-05'] ? table['table_s2-zeile-05'] : '';
    tableRow5[2] = table['table_s3-zeile-05'] ? table['table_s3-zeile-05'] : '';
    tableRow5[3] = table['table_s4-zeile-05'] ? table['table_s4-zeile-05'] : '';
    
    if (tableRow5[0] +
        tableRow5[1] +
        tableRow5[2] +
        tableRow5[3] !== ''){
        tableRows[4] = tableRow5
    };
    
    
    
    const tableRow6 = [];
    tableRow6[0] = table['table_s1-zeile-06'] ? table['table_s1-zeile-06'] : '';
    tableRow6[1] = table['table_s2-zeile-06'] ? table['table_s2-zeile-06'] : '';
    tableRow6[2] = table['table_s3-zeile-06'] ? table['table_s3-zeile-06'] : '';
    tableRow6[3] = table['table_s4-zeile-06'] ? table['table_s4-zeile-06'] : '';
    
    if (tableRow6[0] +
        tableRow6[1] +
        tableRow6[2] +
        tableRow6[3] !== ''){
        tableRows[5] = tableRow6
    };
                    
    const tableRow7 = [];
    tableRow7[0] = table['table_s1-zeile-07'] ? table['table_s1-zeile-07'] : '';
    tableRow7[1] = table['table_s2-zeile-07'] ? table['table_s2-zeile-07'] : '';
    tableRow7[2] = table['table_s3-zeile-07'] ? table['table_s3-zeile-07'] : '';
    tableRow7[3] = table['table_s4-zeile-07'] ? table['table_s4-zeile-07'] : '';
    
    if (tableRow7[0] +
        tableRow7[1] +
        tableRow7[2] +
        tableRow7[3] !== ''){
        tableRows[6] = tableRow7
    };
                        
                        
    const tableRow8 = [];
    tableRow8[0] = table['table_s1-zeile-08'] ? table['table_s1-zeile-08'] : '';
    tableRow8[1] = table['table_s2-zeile-08'] ? table['table_s2-zeile-08'] : '';
    tableRow8[2] = table['table_s3-zeile-08'] ? table['table_s3-zeile-08'] : '';
    tableRow8[3] = table['table_s4-zeile-08'] ? table['table_s4-zeile-08'] : '';
    
    if (tableRow8[0] +
        tableRow8[1] +
        tableRow8[2] +
        tableRow8[3] !== ''){
        tableRows[7] = tableRow8
    };
    
    
    
    const tableRow9 = [];
    tableRow9[0] = table['table_s1-zeile-09'] ? table['table_s1-zeile-09'] : '';
    tableRow9[1] = table['table_s2-zeile-09'] ? table['table_s2-zeile-09'] : '';
    tableRow9[2] = table['table_s3-zeile-09'] ? table['table_s3-zeile-09'] : '';
    tableRow9[3] = table['table_s4-zeile-09'] ? table['table_s4-zeile-09'] : '';
    
    if (tableRow9[0] +
        tableRow9[1] +
        tableRow9[2] +
        tableRow9[3] !== ''){
        tableRows[8] = tableRow9
    };
    
    
    
    const tableRow10 = [];
    tableRow10[0] = table['table_s1-zeile-10'] ? table['table_s1-zeile-10'] : '';
    tableRow10[1] = table['table_s2-zeile-10'] ? table['table_s2-zeile-10'] : '';
    tableRow10[2] = table['table_s3-zeile-10'] ? table['table_s3-zeile-10'] : '';
    tableRow10[3] = table['table_s4-zeile-10'] ? table['table_s4-zeile-10'] : '';
    if (tableRow10[0] +
        tableRow10[1] +
        tableRow10[2] +
        tableRow10[3] !== ''){
        tableRows[9] = tableRow10;}
    

     return (
         <table className="credit-card-table">
             <thead className="credit-card-table image">
             <tr>
                 {tableImages.map((colImage, index) => {
                     if (tableCol[index].length > 0)
                     return (
                     
                     <th key={index}>
                         {colImage &&
                         <img src={colImage} alt="credit card"/>}
                     </th>)
                 })}
             </tr>
             </thead>
             <thead className="credit-card-table header">
             <tr>
                 {tableTitles.map((colTitle, index) => {
                     if (tableCol[index].length > 0)
                     return (
                     <th key={index}>
                         <ReactMarkdown {...MarkdownHelper.allTypes()}
                                        source={MarkdownHelper.parse(colTitle)}
                                        escapeHtml={false} />
                     </th>)
                 })}
             </tr>
             </thead>
             <tbody>
             {tableRows.map((tableRow, index) => (
                 <tr key={index}>
                     {Object.values(tableRow).map((value, index2) => {
                         if (tableCol[index2].length > 0)
                             return (
                         <td key={index2}>
                             <ReactMarkdown {...MarkdownHelper.allTypes()}
                                            source={MarkdownHelper.parse(value)}
                                            escapeHtml={false} />
                         </td>)
                     })}
                 </tr>
             ))}
             </tbody>
         </table>
     )
 }

 export default Table;


// WEBPACK FOOTER //
// ./src/components/ads/creditcard/Table.js